import RestaurantCard from './card';

export { type RestaurantCardProps } from './card';

export { default as RestaurantCardSkeleton, type RestaurantCardSkeletonProps } from './skeleton';

export default RestaurantCard;
